import { Subscription } from 'rxjs';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { FeatureUpgradeService } from './upgrade.service';
import { DispatchExperimentTrackingService } from '@app/dashboard/dispatch/dispatch-experiment-tracking.service';

import { DISPATCH_EXPERIMENT_TRACKING } from '@app/dashboard/dispatch/dispatch-utils';

import { IUpgradeOptions } from './upsell-config';

export interface IVideo {
  imgUrl?: string;
  videoUrl?: string;
}

@Component({
  selector: 'upsell-video-player',
  templateUrl: './upsell-video-player.component.html',
  styleUrls: ['./upsell-video-player.component.scss', '../../styles/upgrade.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoComponent implements OnDestroy, OnInit {
  @ViewChild('upgradeVideo', { static: true }) public upgradeVideo: ElementRef;
  @Input() public options: IUpgradeOptions | IVideo;
  @Input() public isDispatchPricingExperiment: boolean = false;
  public showPlayBtn: boolean = true;
  private videoSubscription: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private featureUpgradeService: FeatureUpgradeService,
    private dispatchExperimentTrackingService: DispatchExperimentTrackingService,
  ) { }

  public ngOnInit(): void {
    this.videoSubscription = this.featureUpgradeService.featureModalHide$.subscribe(() => {
      this.stopVideo();
    });
  }

  public ngOnDestroy(): void {
    this.videoSubscription.unsubscribe();
  }

  public playVideo(): void {
    this.upgradeVideo.nativeElement.play();
    this.upgradeVideo.nativeElement.controls = true;
    this.showPlayBtn = false;

    if (this.isDispatchPricingExperiment) {
      this.dispatchExperimentTrackingService.track(DISPATCH_EXPERIMENT_TRACKING.UPSELL_SCREEN_PLAY_VIDEO);
    }
  }

  public onMouseOver(): void {
    this.upgradeVideo.nativeElement.controls = true;
  }

  public onMouseOut(): void {
    this.upgradeVideo.nativeElement.controls = false;
  }

  public onVideoStop(): void {
    this.showPlayBtn = true;
    this.upgradeVideo.nativeElement.controls = false;
    this.cdr.detectChanges();
  }

  public stopVideo(): void {
    this.upgradeVideo.nativeElement.pause();
    this.upgradeVideo.nativeElement.load();
    this.onVideoStop();
  }
}
